import type { DemoChannel } from '@/types/demo';

type ChannelLogoProps = {
  channel: DemoChannel;
  className?: string;
};

/**
 * Brand mark SVGs for demo channel picker (decorative; labels remain text).
 */
export function ChannelLogo({ channel, className = 'h-5 w-5' }: ChannelLogoProps) {
  if (channel === 'slack') {
    return (
      <svg
        className={className}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="#E01E5A"
          d="M5.5 15.1a2.2 2.2 0 1 1-2.2-2.2h2.2v2.2Zm1.1 0a2.2 2.2 0 1 1 4.4 0v5.5a2.2 2.2 0 1 1-4.4 0v-5.5Z"
        />
        <path
          fill="#36C5F0"
          d="M8.9 5.5a2.2 2.2 0 1 1 2.2-2.2v2.2H8.9Zm0 1.1a2.2 2.2 0 1 1 0 4.4H3.4a2.2 2.2 0 1 1 0-4.4h5.5Z"
        />
        <path
          fill="#2EB67D"
          d="M18.5 8.9a2.2 2.2 0 1 1 2.2 2.2h-2.2V8.9Zm-1.1 0a2.2 2.2 0 1 1-4.4 0V3.4a2.2 2.2 0 1 1 4.4 0v5.5Z"
        />
        <path
          fill="#ECB22E"
          d="M15.1 18.5a2.2 2.2 0 1 1-2.2 2.2v-2.2h2.2Zm0-1.1a2.2 2.2 0 1 1 0-4.4h5.5a2.2 2.2 0 1 1 0 4.4h-5.5Z"
        />
      </svg>
    );
  }

  if (channel === 'teams') {
    return (
      <svg
        className={className}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <rect x="3" y="5" width="12.5" height="14" rx="2.2" fill="#5059C9" />
        <path
          fill="#7B83EB"
          d="M16.2 8.2h3.1c.9 0 1.6.7 1.6 1.6v6.4c0 2-1.6 3.6-3.6 3.6h-1.1V8.2Z"
        />
        <circle cx="18.4" cy="6.2" r="2" fill="#7B83EB" />
        <circle cx="9.2" cy="5.2" r="2.3" fill="#7B83EB" />
        <path
          fill="#fff"
          d="M10.7 10.2H7.8v5.8h1.5v-2h1.1c1.3 0 2.1-.8 2.1-1.9 0-1.1-.8-1.9-1.8-1.9Zm-.3 2.5H9.3v-1.2h1.1c.4 0 .7.2.7.6s-.3.6-.7.6Z"
        />
      </svg>
    );
  }

  if (channel === 'gchat') {
    return (
      <svg
        className={className}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="#34A853"
          d="M4.5 5.8A2.8 2.8 0 0 1 7.3 3h9.4A2.8 2.8 0 0 1 19.5 5.8v7.4a2.8 2.8 0 0 1-2.8 2.8H11l-3.8 3.2c-.7.6-1.7.1-1.7-.8v-2.4H7.3a2.8 2.8 0 0 1-2.8-2.8V5.8Z"
        />
        <circle cx="9" cy="9.6" r="1.15" fill="#fff" />
        <circle cx="12" cy="9.6" r="1.15" fill="#fff" />
        <circle cx="15" cy="9.6" r="1.15" fill="#fff" />
      </svg>
    );
  }

  if (channel === 'email') {
    return (
      <svg
        className={className}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <rect x="2.5" y="5" width="19" height="14" rx="2.5" fill="#4F46E5" />
        <path
          fill="#C7D2FE"
          d="M3.2 6.2 12 12.4 20.8 6.2c-.3-.7-1-1.2-1.8-1.2H5c-.8 0-1.5.5-1.8 1.2Z"
        />
        <path
          fill="#EEF2FF"
          d="M4 17.5h16c.3 0 .5-.1.7-.2L13.2 12 12 12.9 10.8 12 3.3 17.3c.2.1.4.2.7.2Z"
        />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="10" fill="#25D366" />
      <path
        fill="#fff"
        d="M16.7 14.6c-.3-.1-1.6-.8-1.8-.9-.2-.1-.4-.1-.6.1-.2.3-.6.9-.8 1.1-.1.2-.3.2-.6.1-.3-.1-1.1-.4-2.1-1.3-.8-.7-1.3-1.6-1.5-1.9-.1-.3 0-.4.1-.6l.5-.6c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.4-.8-1.9-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.3.3-.9.9-.9 2.1s.9 2.4 1 2.6c.1.2 1.8 2.8 4.4 3.9 1.6.7 2.1.7 2.9.6.4-.1 1.6-.6 1.8-1.3.2-.6.2-1.2.2-1.3 0-.1-.2-.2-.5-.3Z"
      />
    </svg>
  );
}
